import axios from "@/app/Axios";

class Reportes {
    async busquedacarnet(id) {
        try {
            const response = await axios.get(`/reportes_policias/${id}`);
            return response.data;
        } catch (error) {
            if (error.response && error.response.status === 401) {
                return error.response.data;
            } else {
                console.log(error);
            }
        }
    }
    async busquedaresarcimientofuerza(id,id2,id3) {
        try {
            const response = await axios.get(`/reportes/reporteresarcimientosfuerza/${id}/${id2}/${id3}`);
            return response.data;
        } catch (error) {
            if (error.response && error.response.status === 401) {
                return error.response.data;
            } else {
                console.log(error);
            }
        }
    }
    async busquedareposicionesfuerza(id,id2) {
        try {
            const response = await axios.get(`/reportes/reportereposicionesfuerza/${id}/${id2}`);
            return response.data;
        } catch (error) {
            if (error.response && error.response.status === 401) {
                return error.response.data;
            } else {
                console.log(error);
            }
        }
    }
    async busquedapistolafuerza(id,id2) {
        try {
            const response = await axios.get(`/reportes/reportepistolagradofuerza/${id}/${id2}`);
            return response.data;
        } catch (error) {
            if (error.response && error.response.status === 401) {
                return error.response.data;
            } else {
                console.log(error);
            }
        }
    }
    async busquedacuchillofuerza(id,id2) {
        try {
            const response = await axios.get(`/reportes/reportecuchillogradofuerza/${id}/${id2}`);
            return response.data;
        } catch (error) {
            if (error.response && error.response.status === 401) {
                return error.response.data;
            } else {
                console.log(error);
            }
        }
    }
    async busquedasablesfuerza(id,id2) {
        try {
            const response = await axios.get(`/reportes/reportesablesgradofuerza/${id}/${id2}`);
            return response.data;
        } catch (error) {
            if (error.response && error.response.status === 401) {
                return error.response.data;
            } else {
                console.log(error);
            }
        }
    }
}

export default Reportes;